import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { NzRadioButtonStyle, NzRadioModule } from 'ng-zorro-antd/radio';
import { RadioOption } from '../../models/form.model';
import { ControlBase } from '../base/base.component';
import { NzSelectSizeType } from 'ng-zorro-antd/select';

@Component({
  selector: 'control-radio',
  imports: [ReactiveFormsModule, NzRadioModule],
  template: `
    <nz-radio-group
      [class]="baseClasses"
      [formControl]="control()"
      [nzSize]="size()"
      [nzButtonStyle]="buttonStyle()"
    >
      @for (option of options(); track option.value) {
        <label nz-radio [nzValue]="option.value">
          {{ option.label }}
        </label>
      }
    </nz-radio-group>
  `,
})
export class ControlRadioComponent extends ControlBase {
  options = input.required<ReadonlyArray<RadioOption>>();
  size = input<NzSelectSizeType>('default');
  buttonStyle = input<NzRadioButtonStyle>('outline');
}
